module.exports = __webpack_public_path__ + "static/media/13_l_derjprom_0_9.63.ecb8b410.png";